<template>
  <el-main :style="{height:height+'px'}">
    <div class="Scroll_content" :style="{height:height+'px'}">
      <div>
        <div class="simkeropl">{{$t('Change_Plan.ChangePlan')}}</div>
        
        <div class="constn_palyusu">
          <div class="p1">
            <div class="title_play">{{$t('Change_Plan.Current_Plan')}}</div>
            <div class="title_p">12 {{$t('Change_Plan.Months')}}</div>
            <div class="tile_conder">2 {{$t('Change_Plan.kids')}}</div>
            <div class="play_text">$4,188/{{$t('Change_Plan.year')}} ($349/{{$t('Change_Plan.month')}})</div>
          </div>
          <div class="p2">
            <img src="../../assets/Vector 41.svg" alt="">
          </div>
          <div class="p3">
            <div class="title_playkm">{{$t('Change_Plan.New_Plan')}}</div>
            <div class="title_p">12 {{$t('Change_Plan.Months')}}</div>
            <div class="tile_conder">2 {{$t('Change_Plan.kids')}}</div>
            <div class="play_text">$4,188/{{$t('Change_Plan.year')}} ($349/{{$t('Change_Plan.month')}})</div>
          </div>
        </div>


        <div class="constn_palyusu" style="margin-top:30px;">
          <div class="p11">
            <div class="timero">{{$t('Change_Plan.What')}}</div>
            <div class="limder">1. We will process the refund of your individual plan within 24 hours.</div>
            <div class="limder">2. On 2/10/22, your Individuak Plan will</div>
            <div class="limder">3. We will process the refund of your individual plan within 24 hours.</div>
            <div class="limder">4. On 2/10/22, your Individuak Plan will</div>
            <div class="limder">5. We will process the refund of your individual plan within 24 hours.</div>
            <div class="limder">6. On 2/10/22, your Individuak Plan will</div>
            <div class="limder">7. We will process the refund of your individual plan within 24 hours.</div>
            <div class="limder">8. On 2/10/22, your Individuak Plan will</div>
          </div>
          <div class="p22">

          </div>
          <div class="p33">
            <div class="timero">{{$t('MonthlyPassUser.Monthly_Pass_User')}}</div>
            <div class="siner_flmekik">
              <div class="divs">
                <img src="../../assets/80713397.svg" alt="">
              </div>
              <div class="divs sl1">{{$t('MonthlyPassUser.Mastercard_ending_in')}} XXXX</div>
              <div class="divs sl2">{{$t('MonthlyPassUser.Update')}}</div>
            </div>
            <div class="time_play">{{$t('MonthlyPassUser.Expires')}}: MM/YY</div>
          </div>
        </div>


        <div class="play_send">{{$t('Change_Plan.Change_Plan')}}</div>


        <div class="dian mgb"></div>
      </div>
    </div>
  </el-main>
  
</template>
<script>
  import { setStore, getStore, keys } from '@/store';
  // import IndexHeader from '../views/header'
  // import IndexFooter from '../views/footer'
  // import MyScheduled from '../views/scheduled'
  // import MyCourse from '../views/course'
  // import PastLesson from '../views/lesson'

  //引入header组件
  // import Header from '../header/header'

  export default {
    components: {
      // IndexHeader,
      // IndexFooter,
      // MyScheduled,
      // PastLesson,
      // MyCourse,
      // Header
    },
    data () {
      return {
          height:100,
          Package:[]
      }
    },
    created () {
      let height = document.body.offsetHeight-80;
      this.height = height;
            if (getStore(keys.token)) {
        if (getStore(keys.userInfo).status == 0) {
          this.$router.push({
            path: '/sinadd'
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
        return false
      }
      this.get_vip();
    },
    methods: {
      get_vip:function(){
        let id = this.$route.query.plan_id;
        // let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en';
        this.$http.post('/api/getMyChangePlan', {
          plan_id:id
        }).then((res) => {
          if (res.data.code == 200) {
            console.log('升级：',res)
            // this.Package = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      }
    },
    mounted () {

    },
    watch: {

    },
  }
</script>
<style lang="less" scoped>
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    // text-align: center;
    margin-bottom:48.41px;
}
.constn_palyusu{
  width:100%;
  // height: 100px;
  border:0px solid red;
  display: flex;
  .p1{
    // height: 100px;
    border:0px solid red;
    flex:4;
    width: 433px;
    height: 157px;
    background: rgba(240, 240, 240, 0.75);
    .title_play{
      // width: 433px;
      height: 21px;
      background: #C4C4C4;
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 21px;
      /* or 83% */
      color: #000000;
      text-indent: 23px;
    }
    .title_p{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 100%;
      /* identical to box height, or 24px */
      color: #000000;
      margin-top:23px;
      text-indent: 23px;
    }
    .tile_conder{
      // font-family: Sofia Pro;
      // font-style: normal;
      font-size: 14px;
      line-height: 100%;
      /* identical to box height, or 14px */
      color: #000000;
      text-indent: 23px;
      margin-top: 6px;
    }
    .play_text{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 21px;
      /* identical to box height, or 117% */
      color: #000000;
      text-indent: 23px;
      margin-top: 16px;
    }
  }
  .p2{
    height: 100px;
    border:0px solid red;
    flex:1;
    img{
        margin: 70px auto 0 auto;
        display: block;
      }
  }
  .p3{
    border:1px solid #4B69FE;
    flex:4;
    width: 433px;
    height: 157px;
    background: #ffffff;
    .title_playkm{
      background: #4B69FE;
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 21px;
      /* or 83% */
      color: #ffffff;
      text-indent: 23px;
    }
    .title_p{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 100%;
      /* identical to box height, or 24px */
      color: #000000;
      margin-top:23px;
      text-indent: 23px;
    }
    .tile_conder{
      // font-family: Sofia Pro;
      // font-style: normal;
      font-size: 14px;
      line-height: 100%;
      /* identical to box height, or 14px */
      color: #000000;
      text-indent: 23px;
      margin-top: 6px;
    }
    .play_text{
      font-family: Sofia Pro;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 21px;
      /* identical to box height, or 117% */
      color: #000000;
      text-indent: 23px;
      margin-top: 16px;
    }
  }
}
.p11{
  flex: 4;
  .timero{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 27px;
    /* identical to box height, or 100% */
    color: #000000;
    margin-bottom:15px;
  }
  .limder{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    // line-height: 200%;
    /* or 28px */
    margin-bottom: 5px;
    color: #000000;
  }
}
.p22{
  flex: 1;
}
.p33{
  flex: 4;
  .timero{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 27px;
    /* identical to box height, or 100% */
    color: #000000;
    margin-bottom:15px;
  }
  .siner_flmekik{
    display: flex;
    .divs{
      img{
        position: relative;
        top:4px;
        width:26px;
        height:14px;
      }
    }
    .sl1{
        font-family: Sofia Pro;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 23px;
        /* or 164% */
        color: #000000;
        text-indent: 10px;
      }
      .sl2{
        font-family: Sofia Pro;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 100%;
        /* identical to box height, or 14px */
        text-decoration-line: underline;
        color: #000000;
        cursor: pointer;
        text-indent: 24px;
        line-height: 21px;
      }
  }
}
.time_play{
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 100%;
  /* or 13px */
  color: #828282;
  text-indent: 36px;
  margin-top:7px;
}
.play_send{
  width: 310px;
  height: 50px;
  left: 388px;
  bottom: 37px;
  background: #4B69FE;
  border-radius: 50px;
  font-family: Sofia Pro;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  color:#ffffff;
  cursor: pointer;
  margin-top:25px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ChangePlan.vue